<template>
    <div id="currentDeliveryLocationWrapper">
        <div id="currentDeliveryLocationModalOverlay">
        </div>
        <div id="currentDeliveryLocationModalDiv">
            <div id="closeCurrentDeliverLocationDisplay" @click="closeDeliveryLocationDisplay">
                X
            </div>
            <div id="siteNameDiv">
                {{ currentDeliveryLocation.site_name }}
            </div>
            <div id="siteAddressDiv">
                <div id="siteStreetInfoDiv">
                    {{ currentDeliveryLocation.street_number }} {{ currentDeliveryLocation.street_name }}
                </div>
                <div id="siteCityStateZip">
                    {{ currentDeliveryLocation.city }}, {{ currentDeliveryLocation.state }} {{ currentDeliveryLocation.zip }}
                </div>
            </div>
            <div id="siteContactInfoDiv">
                <div id="contactInfoLabels" class="deliverySitecontactInfo">
                    <span v-if="currentDeliveryLocation.phone">
                        Phone:
                    </span>
                    <span v-if="currentDeliveryLocation.fax">
                        Fax:
                    </span>
                    <span v-if="currentDeliveryLocation.email">
                        Email:
                    </span>
                </div>
                <div id="contactInfoData" class="deliverySitecontactInfo">
                    <span v-if="currentDeliveryLocation.phone">
                        {{ currentDeliveryLocation.phone }}
                    </span>
                    <span v-if="currentDeliveryLocation.fax">
                        {{ currentDeliveryLocation.fax }}
                    </span>
                    <span v-if="currentDeliveryLocation.email">
                        {{ currentDeliveryLocation.email }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            currentDeliveryLocation() {
                return this.$store.getters.getDefaultDeliveryLocation;
            }
        },
        methods: {
            closeDeliveryLocationDisplay() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('close', {'event_category': 'delivery_location_display','event_label': eventLabel});
                this.$store.commit('setCurrentDeliveryLocationDisplayOpenStatus', false);
            }
        }
    }
</script>

<style>
    #currentDeliveryLocationModalOverlay {
        position: fixed;
        z-index: 2;
        top: 0;
        left: 0;
        height: calc(100 * var(--vh));
        width: calc(100 * var(--vw));
        background-color: black;
        opacity: .6;
    }

    #currentDeliveryLocationModalDiv {
        position: fixed;
        z-index: 3;
        height: calc(40 * var(--vh));
        width: calc(40 * var(--vw));
        top: calc(30 * var(--vh));
        left: calc(30 * var(--vw));
        background-color: #DFDFDF;
        border-radius: calc(var(--vratio) * 2 * var(--vh));
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 1.5em;
    }

    .inmobile #currentDeliveryLocationModalDiv {
        height: calc(96 * var(--vh));
        width: calc(96 * var(--vw));
        top: calc(2 * var(--vh));
        left: calc(2 * var(--vw));
    }

    #closeCurrentDeliverLocationDisplay {
        position: absolute;
        top: calc(.5 * var(--vw));
        right: calc(.5 * var(--vw));
        color: black;
        cursor: pointer;
        font-weight: bold;
    }

    .inmobile #closeCurrentDeliverLocationDisplay {
        top: calc(2 * var(--vh));
        right: calc(2 * var(--vh));
    }

    #closeCurrentDeliverLocationDisplay:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }

    #siteNameDiv {
        font-size: 1.2em;
    }

    #siteContactInfoDiv {
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    .deliverySitecontactInfo {
        display: flex;
        flex-direction: column;
        justify-self: center;
        margin: calc(2 * var(--vh)) calc(1 * var(--vw));
    }

    #contactInfoLabels {
        align-items: flex-end;
        width: 20%;
    }

    #contactInfoData {
        align-items: flex-start;
        width: 80%;
    }
</style>